
function BezierEasing(mX1, mY1, mX2, mY2) {
    function A(aA1, aA2) {
        return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }

    function B(aA1, aA2) {
        return 3.0 * aA2 - 6.0 * aA1;
    }

    function C(aA1) {
        return 3.0 * aA1;
    }

    // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
    function CalcBezier(aT, aA1, aA2) {
        return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }

    // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
    function GetSlope(aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }

    function GetTForX(aX) {
        // Newton raphson iteration
        var aGuessT = aX;
        for (var i = 0; i < 4; ++i) {
            var currentSlope = GetSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) return aGuessT;
            var currentX = CalcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }

    return function (aX) {
        if (mX1 === mY1 && mX2 === mY2) return aX; // linear
        return CalcBezier(GetTForX(aX), mY1, mY2);
    };
}


export const EASING_TYPE = {
    EASE : BezierEasing(0.25, 0.1, 0.25, 1.0),
    LINEAR: BezierEasing(0.00, 0.0, 1.00, 1.0),
    EASE_IN: BezierEasing(0.42, 0.0, 1.00, 1.0),
    EASE_OUT:  BezierEasing(0.00, 0.0, 0.58, 1.0),
    EASE_IN_OUT: BezierEasing(0.42, 0.0, 0.58, 1.0)
};

export class Easing {

    constructor(private el: any){

    }

    easeIn(options: {x?: number, y?: number, scrollTop?:number, scale?: number, width?: number, height?:number}, duration: number){
        let el = this.el;
        return this.animate(EASING_TYPE.EASE_IN, el, options, duration);
    }

    easeInOut(options: {x?: number, y?: number, scrollTop?:number, scale?: number, width?: number, height?:number}, duration: number){
        let el = this.el;
        return this.animate(EASING_TYPE.EASE_IN_OUT, el, options, duration);
    }

    easeOut(options: {x?: number, y?: number, scrollTop?:number, scale?: number, width?: number, height?:number}, duration: number){
        let el = this.el;
        return this.animate(EASING_TYPE.EASE_OUT, el, options, duration);
    }

    ease(options: {x?: number, y?: number, scrollTop?:number, scale?: number, width?: number, height?:number}, duration: number){
        let el = this.el;
        return this.animate(EASING_TYPE.EASE, el, options, duration);
    }

    linear(options: {x?: number, y?: number, scrollTop?:number, scale?: number, width?: number, height?:number}, duration: number){
        let el = this.el;
        return this.animate(EASING_TYPE.LINEAR, el, options, duration);
    }


    private animate(bezier: Function, el, options: {x?: number, y?: number, scrollTop?:number, scale?: number, width?: number, height?:number}, duration: number){
        // debugger;


        let start = Date.now();
        options.scrollTop = options.scrollTop < 0 ? 0 : options.scrollTop;
        if(typeof options.scrollTop !== 'undefined' && options.scrollTop >= 0 && options.scrollTop <= el.scrollHeight){
            let finalTop = options.scrollTop;

            let height = Math.abs(finalTop - el.scrollTop);
            let direction = (finalTop - el.scrollTop)/height;
            // console.info("currentTop", el.scrollTop);
            // console.info("finalTop", finalTop);
            // console.info("dir", direction);
            (function loop () {

                var p = (Date.now()-start)/duration;
                if(p > 1){
                    p = 1;
                }
                let b = bezier(p);

                let val = el.scrollTop +  (height * b * direction);
                el.scrollTop = val;
                // console.log(b, val, finalTop);
                if(b >= 0 && ((direction > 0 && (val < finalTop)) || (direction < 0 && (val > finalTop)))){
                    requestAnimationFrame(loop);
                }

            }());
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/utils/easing.ts